const escapeCsvValue = (value) => {
  const text = value == null ? "" : String(value);
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const buildMigrationErrorCsv = (errors = []) => {
  const lines = ["code,message,phase,severity"];
  for (const entry of errors) {
    lines.push(
      [
        escapeCsvValue(entry.code),
        escapeCsvValue(entry.message),
        escapeCsvValue(entry.phase),
        escapeCsvValue(entry.severity || "error"),
      ].join(",")
    );
  }
  return `${lines.join("\n")}\n`;
};

export const downloadMigrationErrorCsv = async ({
  serverUrl,
  batchId,
  token,
  fetchImpl = fetch,
}) => {
  const result = await fetchImpl(
    `${serverUrl}/dataMigration/batch/${batchId}/errors`,
    {
      method: "GET",
      headers: {
        Accept: "text/csv",
        ...(token ? { "x-access-token": token } : {}),
      },
    }
  );

  if (!result.ok) {
    const contentType = result.headers.get("Content-Type") ?? "";
    if (contentType.includes("application/json")) {
      const errorBody = await result.json();
      throw new Error(errorBody?.message || "Failed to download migration errors");
    }
    throw new Error("Failed to download migration errors");
  }

  const blob = await result.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  const contentDisposition = result.headers.get("Content-Disposition");
  let fileName = `migration-errors-${batchId}.csv`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename=(.+)/);
    if (match?.[1]) fileName = match[1];
  }
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const partitionMigrationIssues = (errors = []) => {
  const warnings = errors.filter((entry) => entry.severity === "warning");
  const failures = errors.filter((entry) => entry.severity !== "warning");
  return { warnings, failures };
};
